var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0625 8.92188L8.9375 12.8594C8.70312 13.0703 8.35156 13.0703 8.14062 12.8359C7.92969 12.6016 7.92969 12.25 8.16406 12.0391L11.2812 9.0625H3.3125C2.98438 9.0625 2.75 8.82812 2.75 8.5C2.75 8.19531 2.98438 7.9375 3.3125 7.9375H11.2812L8.16406 4.98438C7.92969 4.77344 7.92969 4.39844 8.14062 4.1875C8.35156 3.95312 8.72656 3.95312 8.9375 4.16406L13.0625 8.10156C13.1797 8.21875 13.25 8.35938 13.25 8.5C13.25 8.66406 13.1797 8.80469 13.0625 8.92188Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2e3152de877865b81c8b1ae268d0dd06.svg";
export { ForwardRef as ReactComponent };